module.exports = __webpack_public_path__ + "static/media/rhomberg-logo.63db5fb6.svg";